import React from "react";
import { Form } from "semantic-ui-react";

export default function Notes(props) {
  return (
    <Form.Input fluid label="Notes" placeholder="Enter Notes" type="text" />
  );
}
